import React from 'react';
import { Spin, Typography } from 'antd';
import styles from './ScoringIndicator.module.scss';

const { Text } = Typography;

// Sits in the Next-button slot (SessionInterview's inputDockEnd) while
// evaluate() is the one thing standing between here and "Next Question" —
// the button itself replaces this once the result comes back.
export const ScoringIndicator: React.FC = () => (
  <div className={styles.pill}>
    <Spin size="small" />
    <Text className={styles.label}>Scoring answer…</Text>
  </div>
);
